<template>
    <div v-if="recipientData" class="d-flex flex-column align-items-start justify-content-start">
        <div v-for="data in recipientData" :key="data.id">
            <div v-for="dispatch in data.recipient_dispatch" :key="dispatch.id">
                <font-awesome-icon :class="getStatus(dispatch.status).color" :icon="getStatus(dispatch.status).icon" />
                {{ dispatch.details || 'Success' }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MessageCellRenderer',
    computed: {
        recipientData() {
            return this.params.data && this.params.data.details;
        },
        isMessageColumn() {
            return this.params.isMessage;
        },
    },
    methods: {
        getStatus(status) {
            switch (status) {
                case 0:
                    return {
                        color: 'text-success',
                        icon: ['fas', 'check'],
                    };
                case 1:
                    return {
                        color: 'text-danger',
                        icon: ['fas', 'xmark'],
                    };
                case 2:
                    return {
                        color: 'text-warning',
                        icon: ['fas', 'circle-info'],
                    };
                default: {
                    return {
                        color: '',
                        icon: [],
                    };
                }
            }
        },
    },
};
</script>

<style>
</style>